var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/images/undraw_Taken_re_yn20.png")}}),_c('span',{staticClass:"not-found-title"},[_vm._v("404 Page Not Found")]),_c('span',{staticClass:"not-found-text"},[_vm._v("You're not supposed to be here!")])])])
}]

export { render, staticRenderFns }